import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { AccountsService } from '@hosty-app/services';

import { AccountsStoreEffects } from './accounts-store.effects';
import { accountsStoreFeatureKey, reducer } from './accounts-store.reducers';

export function provideAccountsStore(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideState(accountsStoreFeatureKey, reducer),
    provideEffects([AccountsStoreEffects]),
    AccountsService,
  ]);
}
